import { all } from 'redux-saga/effects';
// TODO: This is an example of watcherSaga import --- Replace it with your watcher saga
import { globalWatcherSaga } from './globalWatcherSaga';
import loginSaga from '../Pages/Login/Login.saga';
import modelListSaga from '../Pages/ModelList/ModelList.saga';
import inferenceSaga from '../Pages/Inference/Inference.saga';
import runtimeHistorySaga from '../Pages/RuntimeHistory/RuntimeHistory.saga';
import modelArchiveSaga from '../Pages/ModelArchive/ModelArchive.saga';
import administrationSaga from '../Pages/Administration/Administration.saga';

// This will be the root saga for all the watcher sagas.
// We'll be using this root saga to run saga middleware
export default function* rootSaga() {
  const watcher = [];
  yield all([
    ...watcher,
    loginSaga(),
    modelListSaga(),
    inferenceSaga(),
    runtimeHistorySaga(),
    modelArchiveSaga(),
    administrationSaga(),
    // TODO This is an example of using the watcher saga in rootSaga
    globalWatcherSaga(),
  ]);
}
